import { animate } from "motion"
import { mediumDownBreakPoint } from "../util/helpers.js"

const frames = {
  top: document.querySelector(".ft-frame.m-top"),
  right: document.querySelector(".ft-frame.m-right"),
  bottom: document.querySelector(".ft-frame.m-bottom"),
  left: document.querySelector(".ft-frame.m-left"),
}

// Check if all frames exist
if (Object.values(frames).every((frame) => frame)) {
  // Final CSS transform values from the CSS file
  const finalTransforms = {
    top: "translateX(-40%)",
    right: "rotate(93deg) translate(50%, 100%)",
    bottom: "translateX(-50%)",
    left: "rotate(90deg) translate(-50%, -100%)",
  }
  const leftPosition = mediumDownBreakPoint.matches ? 0 : "1.5rem"

  // Set initial hidden states
  Object.entries(frames).forEach(([position, element]) => {
    element.style.opacity = "0"
    element.style.transform = finalTransforms[position]

    switch (position) {
      case "top":
        element.style.top = "-3rem" // --frame-height
        break
      case "right":
        element.style.right = "-3rem"
        break
      case "bottom":
        element.style.bottom = "-3rem"
        break
      case "left":
        element.style.left = "-3rem"
        break
    }
  })

  // Animate frames in with stagger
  const animateIn = () => {
    // Animate each frame individually with stagger
    animate(
      frames.top,
      { opacity: 1, top: "0.5rem" },
      { duration: 1, ease: [0, 1.31, 0.3, 1], delay: 0 },
    )
    animate(
      frames.right,
      { opacity: 1, right: 0 },
      { duration: 1, ease: [0, 1.31, 0.3, 1], delay: 0.2 },
    )
    animate(
      frames.bottom,
      { opacity: 1, bottom: 0 },
      { duration: 1, ease: [0, 1.31, 0.3, 1], delay: 0.3 },
    )
    animate(
      frames.left,
      { opacity: 1, left: leftPosition },
      { duration: 1, ease: [0, 1.31, 0.3, 1], delay: 0.4 },
    )
  }

  // Animate frames out
  const animateOut = () => {
    // Animate each frame individually
    animate(
      frames.top,
      { top: "-7rem" },
      { duration: 1, ease: [0, 1.31, 0.3, 1], delay: 0.4 },
    )
    animate(
      frames.right,
      { right: "-7rem" },
      { duration: 1, ease: [0, 1.31, 0.3, 1], delay: 0.3 },
    )
    animate(
      frames.bottom,
      { bottom: "-7rem" },
      { duration: 1, ease: [0, 1.31, 0.3, 1], delay: 0.2 },
    )
    animate(
      frames.left,
      { left: "-7rem" },
      { duration: 1, ease: [0, 1.31, 0.3, 1], delay: 0 },
    )
  }

  // Track current state
  let framesVisible = false

  // Handle scroll
  const handleScroll = () => {
    const scrollPosition = window.scrollY
    const viewportHeight = window.innerHeight

    if (scrollPosition < viewportHeight / 2) {
      if (!framesVisible) {
        animateIn()
        framesVisible = true
      }
    } else {
      // Hide frames when scrolled past first viewport
      if (framesVisible) {
        animateOut()
        framesVisible = false
      }
    }
  }

  // Initial animation on page load
  if (document.body.classList.contains("home")) {
    setTimeout(() => {
      animateIn()
      framesVisible = true
    }, 100)
  } else {
    // For non-home pages, start with frames shown
    Object.entries(frames).forEach(([position, element]) => {
      element.style.opacity = "1"
      switch (position) {
        case "top":
          element.style.top = "0.5rem"
          break
        case "right":
          element.style.right = 0
          break
        case "bottom":
          element.style.bottom = 0
          break
        case "left":
          element.style.left = leftPosition
          break
      }
    })
    framesVisible = true
  }

  // Listen to scroll events
  let scrollTimeout
  window.addEventListener(
    "scroll",
    () => {
      clearTimeout(scrollTimeout)
      scrollTimeout = setTimeout(handleScroll, 10)
    },
    { passive: true },
  )
}
